import { RouteObject } from "react-router-dom";

import { AuthGuard } from "@/auth/guard/authGuard";
import { MainLayout } from "@/layout/Main";
import { getRouteObjects } from "@/routes/config/routes";

export const dashboard: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: getRouteObjects(),
  },
];
